/* eslint-disable jsx-a11y/anchor-is-valid */
/**
 * This component indicates progress in a challenge.
 * It's generalizable enough to be used elsewhere, if need be.
 * TODO(jordan): Look at reusability between this component and
 * <ExerciseProgressPhoneUI>.
 */
import {Trans} from "@lingui/react/macro";
import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import {color} from "@khanacademy/wonder-blocks-tokens";

const getPipColor = (complete: boolean, current: boolean) => {
    if (complete) {
        return color.green;
    }
    if (current) {
        return color.offBlack32;
    }
    return color.offBlack16;
};

type Props = {
    // Which step are we on? (zero-indexed)
    currentStep: number;
    // Callback when a step indicator is clicked
    onClickStep: (arg1: number) => void;
    // The current status of the challenge, where each step's completion
    // state is given as a boolean.
    stepStatus: Array<boolean>;
};

class ChallengeProgress extends React.Component<Props> {
    renderMessage: () => React.ReactNode = () => {
        const {currentStep, stepStatus} = this.props;
        return (
            <Trans>
                Step {Math.min(currentStep + 1, stepStatus.length)}/
                {stepStatus.length}
            </Trans>
        );
    };

    renderPips: () => React.ReactNode = () => {
        const {currentStep, onClickStep, stepStatus} = this.props;
        return (
            <div className={css(styles.pipContainer)}>
                {stepStatus.map((stepComplete, i) => (
                    // eslint-disable-next-line jsx-a11y/anchor-has-content -- TODO: Address a11y error
                    <a
                        className={css(
                            styles.pip,
                            i === 0 && styles.pipFirst,
                            i === stepStatus.length - 1 && styles.pipLast,
                        )}
                        href="javascript:void(0)"
                        key={i}
                        onClick={() => onClickStep(i)}
                        role="button"
                        style={{
                            backgroundColor: getPipColor(
                                stepComplete,
                                currentStep === i,
                            ),
                        }}
                    />
                ))}
            </div>
        );
    };

    render(): React.ReactNode {
        return (
            <div className={css(styles.wrapper)}>
                <div className={css(styles.message)}>
                    {this.renderMessage()}
                </div>
                {this.renderPips()}
            </div>
        );
    }
}

const borderRadius = 5;
const styles = StyleSheet.create({
    message: {
        fontSize: 16,
        marginBottom: 3,
    },
    pip: {
        display: "block",
        height: 10,
        marginRight: 3,
        width: 25,
    },
    pipContainer: {
        borderRadius: 5,
        display: "flex",
        overflow: "hidden",
    },
    pipFirst: {
        borderBottomLeftRadius: borderRadius,
        borderTopLeftRadius: borderRadius,
    },
    pipLast: {
        borderBottomRightRadius: borderRadius,
        borderTopRightRadius: borderRadius,
        marginRight: 0,
    },
    wrapper: {
        display: "block",
    },
});

export default ChallengeProgress;
